import { ServicesGrid } from "@/components/marketing/ServicesGrid";
import { HowItWorks } from "@/components/marketing/HowItWorks";
import { BeforeAfterSlider } from "@/components/marketing/BeforeAfterSlider";
import { TestimonialsCarousel } from "@/components/marketing/TestimonialsCarousel";
import { FAQAccordion } from "@/components/marketing/FAQAccordion";
import { CTAButton } from "@/components/common/CTAButton";

export default function ServicesPage() {
  // Debug: render log to trace header-spacing issues
  console.log("[ServicesPage] render");

  return (
    <div
      className="min-h-screen bg-background"
      style={{
        // Push content below sticky global header (same pattern used on LoginPage)
        paddingTop:
          "calc(var(--site-header-height, 96px) + env(safe-area-inset-top, 0px) + 16px)",
      }}
    >
      <main className="w-full">
        {/* Hero section */}
        <section className="relative pt-16 pb-16 md:pt-24 md:pb-20 bg-gradient-to-b from-secondary/30 to-background">
          <div className="zaklyn-container">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground mb-6">
                Services Crafted for You
              </h1>
              <p className="text-lg md:text-xl text-foreground/70 mb-8">
                From alterations to custom stitching, every service is designed with the modern Indian woman in mind.
              </p>
              <CTAButton href="/customer/measurements/book" size="lg">
                Get Started Today
              </CTAButton>
            </div>
          </div>
        </section>

        {/* Content sections */}
        <section aria-label="Services grid">
          <ServicesGrid />
        </section>

        <section aria-label="How it works">
          <HowItWorks />
        </section>

        <section aria-label="Before and after showcase">
          <BeforeAfterSlider />
        </section>

        <section aria-label="Testimonials">
          <TestimonialsCarousel />
        </section>

        <section aria-label="Frequently asked questions" className="pb-8">
          <FAQAccordion />
        </section>
      </main>
    </div>
  );
}